import React from 'react';
import './UnassignedUpcomingModal.css';

export interface UnassignedUpcomingItem {
  date: string;
  route: string;
  vehicleType: string;
  memo: string;
}

interface UnassignedUpcomingModalProps {
  open: boolean;
  items: UnassignedUpcomingItem[];
  onClose: () => void;
}

const UnassignedUpcomingModal: React.FC<UnassignedUpcomingModalProps> = ({
  open,
  items,
  onClose
}) => {
  if (!open) return null;

  return (
    <div className="unassigned-upcoming-overlay" role="dialog" aria-modal="true">
      <div className="unassigned-upcoming-panel" onClick={e => e.stopPropagation()}>
        <h2 className="unassigned-upcoming-title">미배차 사전 알림</h2>
        <div className="unassigned-upcoming-alert">
          미배차 항목이 존재합니다
          <br />
          미리 배차를 진행하세요 !!!
        </div>

        <div className="unassigned-upcoming-table-wrap">
          <table className="unassigned-upcoming-table">
            <thead>
              <tr>
                <th>날짜</th>
                <th>운송구간</th>
                <th>차종</th>
                <th>메모</th>
              </tr>
            </thead>
            <tbody>
              {items.map((row, idx) => (
                <tr key={`${row.date}-${row.route}-${idx}`}>
                  <td>{row.date}</td>
                  <td className="cell-left">{row.route || '—'}</td>
                  <td>{row.vehicleType || '—'}</td>
                  <td className="cell-left cell-memo">{row.memo || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="unassigned-upcoming-actions">
          <button type="button" className="unassigned-upcoming-btn-yes" onClick={onClose}>
            예
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnassignedUpcomingModal;
